import type SSOError from 'bundles/authentication-common/components/sso/SSOError';
import { InvalidDomainSSOError } from 'bundles/authentication-common/components/sso/SSOError';
import { SSOTypes } from 'bundles/third-party-auth/lib';

export const SSO_VARIANT = {
  SOCIAL: 'social',
  CUSTOM: 'custom',
  NONE: 'none',
} as const;

export type SSO_VARIANT_KEY = (typeof SSO_VARIANT)[keyof typeof SSO_VARIANT];

export function getSSOVariant({
  authProvider,
  isEnterprise,
}: {
  authProvider?: string;
  isEnterprise?: boolean;
}): SSO_VARIANT_KEY {
  if (authProvider) {
    return SSO_VARIANT.CUSTOM;
  }
  if (isEnterprise) {
    return SSO_VARIANT.NONE;
  }
  return SSO_VARIANT.SOCIAL;
}

// Only LTI's invalid-domain redirect should be completed via thirdPartyAuth.connect.
// SAML's DOMAIN_VERIFICATION_FAILED case is handled separately via its magic-link resend flow.
export const isLtiInvalidDomainSSOError = (error?: SSOError): error is InvalidDomainSSOError =>
  error instanceof InvalidDomainSSOError && error.method?.toLowerCase() === SSOTypes.LTI;
